<template>
    <div class="container">
        <transition-group>
            <div class="message" v-for="message in messages" :key="message" @click="remove(message)"> 
                <div class="border">
                    <label>
                        <img src="./assets/error.png" style="width: 24px">
                        {{message.title}}
                    </label>
                    <div style="line-height: 20px;">
                        {{message.content}}
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
export default {
    data(){
        return {
            messages:  [],
            isShow: true,
            ids: 0,
        }
    },
    methods: {
        show(title, content){
            const message = {
                id: ++this.ids,
                title: title,
                content: content,
            }
            this.messages.push(message)

            setTimeout(() => {
                this.remove(message)
            }, 5000)
        },
        remove(message){
            const index = this.messages.findIndex(msg => msg.id == message.id);
            if (index !== -1) {
                this.messages.splice(index, 1);
            }
        },
        test(){
            this.show('Test', 'Testtttt')
        }
    },
    mounted(){
    }
}
</script>

<style scoped>
.container{
    position: fixed;
    top: 0; right: 0;
    z-index: 3; 
    width: max-content; height: max-content;
    display: flex; justify-content: center; align-items: center;
    flex-direction: column;
}

.message{
    width: 220px; height: 120px; background: #FDEDEE;
    margin: 10px 10px 0 0;
    color: #FE5454;
    overflow: hidden;
}

.border{
    border: 3px solid #FE5454;
    width: 100%;
    height: 100%;
    padding: 8px;
    display: flex; flex-direction: column; gap: 5px;
}

.message label{
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 16px;
    font-weight: 600;
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease-out, transform 0.5s ease-out;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
    transform: translate(100%);
}
</style>